import { useIsMobileHook } from '@teliaee/telia-common-components';
import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Table } from 'telia-front-react';
import RoamingStore from '../../stores/RoamingStore';
import { getSubarrayOfResults } from '../../util/ObjectUtil';
import { PwsNumber } from '../RoamingInterfaces';
import ShowMoreButton from './ShowMoreButton';
import {
  renderSpecialInformationDesktopTableHeading,
  renderSpecialInformationDesktopTableRow,
  renderSpecialInformationMobileTableRow,
} from './SpecialAndEmergencyInformationTables';

interface DangerInformationProps {
  roamingStore?: RoamingStore;
}

const DangerInformation = (props: DangerInformationProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const { isMobile } = useIsMobileHook();
  const {
    roamingStore: {
      berecTable: { pwsNumbers, numberOfVisibleResults },
    },
  } = props;
  const visiblePwsInformation = getSubarrayOfResults(pwsNumbers, numberOfVisibleResults.pwsNumbers);
  const tableHeadingAccessibility = translate('roaming.specialInformation.tableHeading.accessibility');
  const tableHeadingType = translate('roaming.specialInformation.tableHeading.type');
  const tableHeadingDescriptionLink = translate('roaming.specialInformation.tableHeading.descriptionLink');
  const tableHeadingDownloadLink = translate('roaming.specialInformation.tableHeading.downloadLink');
  const tableHeadingAdditionalInformation = translate('roaming.specialInformation.tableHeading.additionalInformation');

  const getTableRowValues = (info: PwsNumber): { [key: string]: string } => ({
    [tableHeadingAccessibility]: info.pwsMeansOfAccess,
    [tableHeadingType]: info.typeOfPws,
    [tableHeadingDescriptionLink]: info.linkToPwsDescription,
    [tableHeadingDownloadLink]: info.linkToPwsDownload,
    [tableHeadingAdditionalInformation]: info.additionalInformation,
  });

  return (
    <>
      {isMobile ? (
        <Table responsive="rows" break="md" className="text__margin-none">
          {visiblePwsInformation.map((info, index) => renderSpecialInformationMobileTableRow(`danger-info-${index}`, index, getTableRowValues(info)))}
        </Table>
      ) : (
        <Table responsive="rows" className="text__margin-none">
          <thead>
            {renderSpecialInformationDesktopTableHeading(
              'danger-info',
              [tableHeadingAccessibility, tableHeadingType, tableHeadingDescriptionLink, tableHeadingDownloadLink, tableHeadingAdditionalInformation],
              [2, 2, 3, 3, 2],
            )}
          </thead>
          <tbody>
            {visiblePwsInformation.map((info, i) => renderSpecialInformationDesktopTableRow(`danger-info-row-${i}`, getTableRowValues(info), [2, 2, 3, 3, 2]))}
          </tbody>
        </Table>
      )}
      <ShowMoreButton category="pwsNumbers" />
    </>
  );
};

export default inject('roamingStore')(observer(DangerInformation));
